import { useMemo } from 'react'

import { useBookkeepingBankAccounts } from '@features/accounts/hooks/useBookkeepingBankAccounts'

export const useIsCashPilotEnabled = () => {
  const { bookkeepingBankAccounts } = useBookkeepingBankAccounts()

  return useMemo(() => {
    // CashPilot is only enabled for user with at least one shine or open banking account
    return bookkeepingBankAccounts.some(
      (account) => !account.isArchived && account.isBankAccount && !!account.externalId,
    )
  }, [bookkeepingBankAccounts])
}
